import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
// eslint-disable-next-line @trello/enforce-component-boundaries
import { HeaderSkeleton } from 'app/src/components/HeaderSkeleton';

export const Header = () => {
  const ReduxHeader = useLazyComponent(() =>
    import(/* webpackChunkName: "header" */ 'app/gamma/src/components/header'),
  );
  return (
    <div
      data-desktop-id="header"
      style={{
        // 32px tall, plus 4px padding-{top,bottom}. The {min,max}-height
        // combo alongside overflow: hidden is necessary to prevent render
        // jank (specifically on the home route). We should fix this at some
        // point
        minHeight: '40px',
        maxHeight: '40px',
        overflow: 'hidden',
      }}
    >
      <Suspense fallback={<HeaderSkeleton />}>
        <ReduxHeader />
      </Suspense>
    </div>
  );
};
